import { TabView, TabPanel } from 'primereact/tabview';
import { cn } from '@/components/ui/cn';
import { useState } from 'react';

interface TabItem {
	header: string;
	content?: React.ReactNode;
}

interface StyledTabViewProps {
	tabs: TabItem[];
	defaultIndex?: number;
}

const StyledTabView = ({ tabs, defaultIndex = 0 }: StyledTabViewProps) => {
	const [activeIndex, setActiveIndex] = useState(defaultIndex);
	const tabViewPt = {
		nav: { className: 'h-12 w-[360px] bg-transparent grid grid-cols-2' },
		inkbar: { className: 'bg-primary h-[3px] rounded-t-[100px]' },
		panelContainer: { className: tabs[activeIndex].content === undefined ? 'p-0' : 'p-0 pt-6' },
	};
	const tabPanelPt = (index: number) => ({
		header: { className: 'mx-auto w-fit' },
		headerAction: { className: 'bg-transparent h-full px-0 py-0' },
		headerTitle: { className: cn('font-poppins text-title-small2', activeIndex === index ? 'text-primary' : 'text-neutralVariant20') },
	});

	return (
		<TabView
			activeIndex={activeIndex}
			onTabChange={(e) => setActiveIndex(e.index)}
			pt={tabViewPt}
			children={tabs.map((tab, index) => (
				<TabPanel
					key={index}
					pt={tabPanelPt(index)}
					header={tab.header}
					children={tab.content}
				/>
			))}
		/>
	);
}

export default StyledTabView;
